"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallScriptAcquisitionWorker = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const os = require("os");
const path = require("path");
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
const Debugging_1 = require("../Utils/Debugging");
const FileUtilities_1 = require("../Utils/FileUtilities");
const InstallIdUtilities_1 = require("../Utils/InstallIdUtilities");
const WebRequestWorkerSingleton_1 = require("../Utils/WebRequestWorkerSingleton");
class InstallScriptAcquisitionWorker {
    constructor(context) {
        this.context = context;
        this.scriptAcquisitionUrl = 'https://builds.dotnet.microsoft.com/dotnet/scripts/v1/dotnet-install.';
        this.scriptFileEnding = os.platform() === 'win32' ? 'ps1' : 'sh';
        const scriptFileName = 'dotnet-install';
        this.scriptFilePath = path.join(__dirname, 'install scripts', `${scriptFileName}.${this.scriptFileEnding}`);
        this.webWorker = WebRequestWorkerSingleton_1.WebRequestWorkerSingleton.getInstance();
        this.fileUtilities = new FileUtilities_1.FileUtilities();
    }
    getDotnetInstallScriptPath() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                Debugging_1.Debugging.log('getDotnetInstallScriptPath() invoked.');
                const script = yield this.webWorker.getCachedData(`${this.scriptAcquisitionUrl}${this.scriptFileEnding}`, this.context);
                if (!script) {
                    Debugging_1.Debugging.log('The request to acquire the script failed.');
                    throw new EventStreamEvents_1.EventBasedError('NoInstallScriptPathExists', 'Unable to get script path.');
                }
                yield this.fileUtilities.writeFileOntoDisk(script, this.scriptFilePath, this.context.eventStream);
                this.context.eventStream.post(new EventStreamEvents_1.DotnetInstallScriptAcquisitionCompleted());
                return this.scriptFilePath;
            }
            catch (error) {
                Debugging_1.Debugging.log('An error occurred processing the install script.');
                this.context.eventStream.post(new EventStreamEvents_1.DotnetInstallScriptAcquisitionError(error, (0, InstallIdUtilities_1.getInstallFromContext)(this.context)));
                // Try to use fallback install script
                const fallbackPath = this.getFallbackScriptPath();
                if ((yield this.fileUtilities.exists(fallbackPath))) {
                    Debugging_1.Debugging.log('Returning the fallback script path.');
                    this.context.eventStream.post(new EventStreamEvents_1.DotnetFallbackInstallScriptUsed());
                    return fallbackPath;
                }
                throw new EventStreamEvents_1.EventBasedError('UnableToAcquireDotnetInstallScript', `Failed to Acquire Dotnet Install Script: ${error}`);
            }
        });
    }
    getFallbackScriptPath() {
        return this.scriptFilePath;
    }
}
exports.InstallScriptAcquisitionWorker = InstallScriptAcquisitionWorker;
//# sourceMappingURL=InstallScriptAcquisitionWorker.js.map